/**
 * @hidden
 */
var noop = function () { };
export { noop };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-common/dist/es/noop.js
// module id = 785
// module chunks = 93